import create from "zustand";
export const useNotificationConsole = create((set) => ({
    isExpanded: false,
    consoleData: undefined,
    inProgressConsoleDataIdToBeDeleted: "",
    consoleAnimationFinished: false,
    expandConsole: () => set((state) => (Object.assign(Object.assign({}, state), { isExpanded: true }))),
    setIsExpanded: (isExpanded) => set((state) => (Object.assign(Object.assign({}, state), { isExpanded }))),
    setNotificationConsoleData: (consoleData) => set((state) => (Object.assign(Object.assign({}, state), { consoleData }))),
    setInProgressConsoleDataIdToBeDeleted: (id) => set((state) => (Object.assign(Object.assign({}, state), { inProgressConsoleDataIdToBeDeleted: id }))),
    setConsoleAnimationFinished: (consoleAnimationFinished) => set({ consoleAnimationFinished: consoleAnimationFinished }),
}));
